import { helpers } from '@vuelidate/validators'
import type { ISelectOptions, ISelectValue } from './useSelect.types'
import type { TInstance } from '@/components/Inputs/Composables/validators/validators.types'

function getSelectValue(value: ISelectValue | null | undefined) {
  return value?.value
}

export function useSelect(
  field: string,
  t: TInstance,
  options: ISelectOptions = { required: true },
) {
  return ({
    [`${field}`]: {
      ...(options.required && {
        required: helpers.withMessage(
          () => t('formValidatorMessages.select.required'),
          (value: ISelectValue | null | undefined) => {
            const selected = getSelectValue(value)
            return selected !== undefined && selected !== null && selected !== ''
          },
        ),
      }),
    },
  })
}
